import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Stack, IconButton, InputAdornment, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// hooks
import useAuth from 'hooks/useAuth';

// components
import { FormProvider, RHFTextField } from 'components/hook-form';

import { ReactComponent as EyeOffIcon } from 'assets/images/svg/eye_off.svg';
import { ReactComponent as EyeOnIcon } from 'assets/images/svg/eye_on.svg';
// ----------------------------------------------------------------------

export default function LoginForm() {
  const { error, login } = useAuth();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string().trim().required(t('errors.required')),
    password: Yup.string().trim().required(t('errors.required')),
  });

  const defaultValues = {
    email: '',
    password: '',
  };

  const methods = useForm({
    reValidateMode: 'onBlur', 
    resolver: yupResolver(LoginSchema),
    defaultValues
  });

  const {
    setFocus,
    handleSubmit,
    formState: { errors }

  } = methods;

  useEffect(() => {
    // Ensure that the effect runs only after the errors are populated
    if (Object.keys(errors).length > 0) {
      const firstError = Object.keys(errors)[0]; // Get the first error field
      setFocus(firstError); // Focus the first error field
    }
    
  }, [errors, setFocus]);

  const onSubmit = async (data) => {
    setIsLoading(true);
    await login(data.email, data.password);
    setIsLoading(false);
  };
  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box className="form_message form_message_error" >
        {error && t(`login.errors.${error}`)}
      </Box>
      <Box className="wrapper_intro_form_tilte">{t('login.form.title')}</Box>
      <Stack spacing={3}>
        <RHFTextField
          name="email"
          placeholder={t('login.form.email')} />
        <RHFTextField
          name="password"
          placeholder={t('login.form.password')}
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <EyeOffIcon /> : <EyeOnIcon />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </Stack>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          '& > button': { m: 1, minWidth: 150 }
        }}
      >
        <LoadingButton
          fullWidth
          color="primary"
          size="large"
          type="submit"
          className="form_submit"
          variant="contained"
          loading={isLoading}

        >
          {t('login.form.login')}

        </LoadingButton>
      </Box>
    </FormProvider>
  );
}
